<template>
  <ul v-if="box.children.length">
    <li v-for="child in box.children" :key="child.name">
      <DialogSettingsPreferencesBoxBlock
        v-if="child.type === 'box'"
        :box="child"
      />

      <DialogSettingsPreferencesBoxCheck v-else :preference="child" />
    </li>
  </ul>
</template>
<script setup lang="ts">
interface Props {
  box: any;
}

defineProps({
  box: null
});
</script>

<style lang="scss" scoped>
ul {
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: 1fr;
  gap: var(--gap_s);
}
</style>
